import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from '../services/interceptor.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { GuardsGuard } from './guards.guard';
import { SetContextComponent } from './set-context/set-context.component';
import { RouterModule } from '@angular/router';
import { StaticContentModule } from '../pages/static-content/static-content.module';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { StaticContentRoutingModule } from '../pages/static-content/static-content-routing.module';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatIconModule } from '@angular/material/icon';
import {  MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        MatSelectModule,
        OverlayModule,
        MatIconModule,
        MatDialogModule,
        MatFormFieldModule,
        StaticContentModule,
        StaticContentRoutingModule,
        FormsModule,
        MatInputModule,
        MatButtonModule,
        MatMenuModule,
        MatTooltipModule
    ],
    providers: [GuardsGuard],
    declarations: [HeaderComponent, FooterComponent, SetContextComponent],
    exports: [HeaderComponent, FooterComponent]
})
export class LayoutModule {
  static forRoot(): ModuleWithProviders<LayoutModule> {
    return {
      ngModule: LayoutModule,

      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: InterceptorService,
          multi: true
        }
      ]
    };
  }
}
